export default __webpack_public_path__ + "static/media/arrow-up.8bf7dc78.svg";